/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsVialRotateLeft: {
  name: 'vial-rotate-left';
  data: string;
} = {
  name: 'vial-rotate-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 2a1 1 0 0 0 0 2h1v14a4 4 0 0 0 8 0V4h1a1 1 0 1 0 0-2H3Zm7 2H6v4h4V4ZM6 18v-8h4v8a2 2 0 1 1-4 0Zm9-11a1 1 0 0 1 1 1v.257a4.498 4.498 0 0 1 5.932 5.022 4.5 4.5 0 0 1-8.457 1.233 1 1 0 0 1 1.789-.894 2.5 2.5 0 1 0 1.645-3.547l.146.097a1 1 0 0 1-1.11 1.664l-1.5-1A1 1 0 0 1 14 10V8a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
